// extracted by mini-css-extract-plugin
export default {"form__footer":"ConfirmDelete_form__footer__M7vH0","figure":"ConfirmDelete_figure__d9KDt","text__confirm":"ConfirmDelete_text__confirm__kKmM5"};